export default "__VITE_ASSET__BLoKzWwh__"